import {
  FiEye,
  FiClock,
  FiThumbsUp,
  FiMessageCircle,
} from "react-icons/fi";

const formatDuration = (ms = 0) => {
  if (!ms) return "0:00";
  const totalSeconds = Math.floor(ms / 1000);
  const min = Math.floor(totalSeconds / 60);
  const sec = totalSeconds % 60;
  return `${min}:${sec.toString().padStart(2, "0")}`;
};

export default function VideoCard({ video, onClick }) {
  const thumbnail = video.videoImage || "/no-thumb.png";

  const views =
    video.totalViews ?? video.views ?? video.viewsCount ?? 0;
  const likes = video.like ?? video.likes ?? 0;
  const comments =
    video.totalComments ?? video.comments ?? 0;

  return (
    <div style={styles.card} onClick={onClick}>
      <div style={{ position: "relative" }}>
        <img src={thumbnail} alt={video.title} style={styles.thumb} />

        {video.videoTime && (
          <div style={styles.duration}>
            <FiClock size={12} />
            {formatDuration(video.videoTime)}
          </div>
        )}
      </div>

      <div style={styles.info}>
        <h4 style={styles.title}>{video.title}</h4>

        <div style={styles.metaRow}>
          <FiEye size={13} /> {views} views
        </div>

        <div style={styles.metaRow}>
          <span style={styles.metaItem}>
            <FiThumbsUp size={13} /> {likes}
          </span>
          <span style={styles.metaItem}>
            <FiMessageCircle size={13} /> {comments}
          </span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    cursor: "pointer",
    borderRadius: 10,
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    width: 220,
    flexShrink: 0,
  },
  thumb: {
    width: "100%",
    height: 140,
    objectFit: "cover",
    background: "#eee",
  },
  duration: {
    position: "absolute",
    right: 6,
    bottom: 6,
    background: "rgba(0,0,0,0.75)",
    color: "#fff",
    fontSize: 11,
    padding: "2px 6px",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  info: {
    padding: 10,
  },
  title: {
    fontSize: 14,
    margin: "0 0 6px",
    lineHeight: 1.3,
  },
  metaRow: {
    fontSize: 12,
    color: "#777",
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 4,
  },
  metaItem: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
};
